module.exports = __webpack_public_path__ + "img/about-us-boss.fe4ed6d8.jpeg";